import _ from 'lodash';
import { connect } from 'react-redux';
import {
	add,
	activate,
	cancel,
	confirm,
	estimate,
	get,
	getCarrierEmail,
	publicGet,
	searchLogs,
	uncancel,
	verify,
	update,
} from '../../modules/logistics/stationDelivery';
import { lookup as lookupAssignedLoadingNumbers } from '../../modules/logistics/assignedLoadingNumber';
import { showErrors } from '../../modules/general';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {
	let stationDelivery;
	let stationDeliveryId;

	if (ownProps.stationDelivery) {
		stationDelivery = ownProps.stationDelivery;
		stationDeliveryId = stationDelivery.stationDeliveryId;
	} else {
		stationDeliveryId = ownProps.stationDeliveryId
			? ownProps.stationDeliveryId
			: _.get(ownProps, ['match', 'params', 'stationDeliveryId']);
		stationDelivery = _.get(state.maps, ['stationDelivery', stationDeliveryId]);
	}

	let stationDeliveryLogs = [];
	/** @namespace state.lists.stationDeliveryLogIds **/
	/** @namespace state.lists.stationDeliveryLog **/

	if (state.lists.stationDeliveryLogIds && state.lists.stationDeliveryLogIds[stationDeliveryId]) {
		stationDeliveryLogs = _.map(
			state.lists.stationDeliveryLogIds[stationDeliveryId],
			(id) => state.maps.stationDeliveryLog[id]
		);
	}

	return {
		stationDelivery,
		stationDeliveryLogs,
		stationMap: state.maps.station,
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		carrierMap: state.maps.carrier,
		terminalMap: state.maps.terminal,
		supplierMap: state.maps.supplier,
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			addDelivery: add,
			activateDelivery: activate,
			cancelDelivery: cancel,
			uncancelDelivery: uncancel,
			estimateDelivery: estimate,
			getDelivery: get,
			publicGetDelivery: publicGet,
			getStationDeliveryCarrierEmail: getCarrierEmail,
			updateDelivery: update,
			confirmDelivery: confirm,
			searchDeliveryLogs: searchLogs,
			verifyDelivery: verify,
			lookupAssignedLoadingNumbers,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
